<template>
    <div class="product">
        <navBar></navBar>
        <div class="p-banner"></div>
        <div class="p-title">
            <img class="p-header" src="https://restaskimg.civaonline.cn/imagesH5/product/header.png" alt="">
            <div class="p-title-r">
                <div class="p-title-txt">Civa机器人</div>
                <div class="p-title-intro">Civa机器人让孩子高效学习，快乐成长</div>
            </div>
        </div>
        <div class="p-content p-content-stu">
            <div class="p-content-item p-item-1">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/stu-1.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>我的课程</span></h4>
                    <p class="p-item-text-intro">线下课堂配套，帮助孩子课前预习，课后复习</p>
                </div>
            </div>
            <div class="p-content-item mar-t198">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/stu-2.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>我的作业</span></h4>
                    <p class="p-item-text-intro">自动批改，匹配讲解，与线下课堂无缝衔接</p>
                </div>
            </div>
            <div class="p-content-item mar-t222">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/stu-3.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>探究学习</span></h4>
                    <p class="p-item-text-intro">探索研究，趣味学习，知识应用</p>
                </div>
            </div>
            <div class="p-content-item mar-t240">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/stu-4.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>学习报表</span></h4>
                    <p class="p-item-text-intro">汇总展现，智能分析，查漏补缺</p>
                </div>
            </div>
        </div>
        <div class="line"></div>
        <div class="p-title">
            <img class="p-header" src="https://restaskimg.civaonline.cn/imagesH5/product/header.png" alt="">
            <div class="p-title-r">
                <div class="p-title-txt">EnglishPal</div>
                <div class="p-title-intro">专注于提高学生的视听说能力</div>
            </div>
        </div>
        <div class="p-content p-content-stu p-content-b">
            <div class="p-content-item">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/stu-5.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>EnglishPal</span></h4>
                    <p class="p-item-text-intro">EnglishPal 专注于提高学生的视听说能力。通过互动课程、口语训练、线上社群等核心功能打造出兴趣学习氛围，根据用户不同的学习情况智能推送、推荐更符合个人能力和兴趣的内容，让学生在不知不觉中提高视听说能力
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
}
</script>

<style scoped lang="less">
.product{
    .p-banner{
        background: url("https://restaskimg.civaonline.cn/imagesH5/s-banner.png") no-repeat center center / cover;
    }
    .p-content{
        padding: 0 32px 80px;
        .p-content-item{
            background: #FBF2FF;
            height: 428px;
            margin-top: 136px;
            img{
                width: 556px;
                margin-top: -136px;
            }
            .p-item-text{
                margin-top: 20px;
            }
        }
        .p-item-1{
            height: 435px;
            img{
                width: 507px;
                margin-top: -128px;
            }
        }
        .mar-t198{
            margin-top: 198px;
        }
        .mar-t222{
            margin-top: 223px;
            img{
                margin-top: -139px;
            }
        }
        .mar-t240{
            margin-top: 240px;
        }
    }
    .p-content-b{
        padding-bottom: 170px;
        .p-content-item{
            height: 588px;
            margin-top: 220px;
            img{
                margin-top: -152px;
            }
            .p-item-text{
                margin-top: 34px;
                .p-item-text-title:before{
                    width: 155px;
                }
            }
            p{
                text-align: left;
            }
        }
    }
}
</style>
